import {
  Activity,
  Brain,
  CheckCircle,
  DollarSign,
  Gauge,
  Globe,
  ImageIcon,
  Monitor,
  Scale,
  ScanText,
  Search,
  ShieldCheck,
  Text,
  Wand,
  Zap,
  type LucideIcon,
} from "lucide-react";

// Apart from ModelSelectField so a component that only names a preset does not
// load the whole field (and the form, editors and stylesheets it pulls in).
const PRESET_ICONS: Record<string, LucideIcon> = {
  activity: Activity,
  brain: Brain,
  "check-circle": CheckCircle,
  "dollar-sign": DollarSign,
  gauge: Gauge,
  globe: Globe,
  image: ImageIcon,
  monitor: Monitor,
  scale: Scale,
  "scan-text": ScanText,
  search: Search,
  "shield-check": ShieldCheck,
  text: Text,
  wand: Wand,
  zap: Zap,
};

export function resolvePresetIcon(name: string | undefined): LucideIcon | null {
  if (!name) return null;
  return PRESET_ICONS[name] ?? null;
}
